/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="11.5"
        height="19"
        viewBox="0 0 11.5 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 19h11.5V0H0ZM10.5 1v17H1V1ZM9.27 14.17V2.22H2.19v11.95Zm-3.52 1.06a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm2.52-12v9.95H3.19V3.24Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'MobileDeviceIcon';

export default Icon;
